import { render } from "./ShowBooking.vue?vue&type=template&id=532f07c8&scoped=true"
import script from "./ShowBooking.vue?vue&type=script&lang=js"
export * from "./ShowBooking.vue?vue&type=script&lang=js"

import "./ShowBooking.vue?vue&type=style&index=0&id=532f07c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532f07c8"]])

export default __exports__